import type { Memory, TvData, TvPhoto } from "./types";
import { isWediaryConfigured } from "./wediary";

export type TvSlide =
  | { type: "welcome"; id: string }
  | { type: "memory"; id: string; memory: Memory }
  | { type: "photo"; id: string; photo: TvPhoto }
  | { type: "program"; id: string }
  | { type: "gallery"; id: string };

export function buildTvPlaylist(data: TvData): TvSlide[] {
  const slides: TvSlide[] = [{ type: "welcome", id: "welcome" }];
  const photos = data.photos ?? [];
  const alternatingCount = Math.max(photos.length, data.memories.length);

  for (let index = 0; index < alternatingCount; index += 1) {
    const photo = photos[index];
    if (photo) {
      slides.push({ type: "photo", id: `photo-${photo.id}`, photo });
    }

    const memory = data.memories[index];
    if (memory) {
      slides.push({ type: "memory", id: `memory-${memory.id}`, memory });
    }
  }

  if (data.tv.showProgram) {
    slides.push({ type: "program", id: "program" });
  }
  if (data.tv.showWediary && isWediaryConfigured(data.site.wediaryUrl)) {
    slides.push({ type: "gallery", id: "gallery" });
  }

  return slides;
}
